import React from 'react';

import { DESKTOP_MIN_WIDTH, OBJECT_DEFAULT } from 'constants';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import {
  displayFlexRowCenterStartMixin,
  paragraph500Mixin,
  paragraph700Mixin,
  textBreakLineWordMixin,
} from 'styles';

const FormInputDisplayOnly = ({
  name = '',
  label = '',
  value = '',
  styles = OBJECT_DEFAULT,
  inputStyles = OBJECT_DEFAULT,
  isRequired = false,
}) => {
  const { t } = useLang();

  return (
    <FormGroupStyled style={styles || {}}>
      <FormLabel>
        {t(label)}
        {isRequired && <span>*</span>}
      </FormLabel>
      <FormControlDisplay name={name} style={inputStyles || {}} isReadOnly>
        {value || ''}
      </FormControlDisplay>
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;

const FormControlDisplay = styled.div`
  ${paragraph500Mixin};
  text-transform: uppercase;
  min-height: 44px;
  border-radius: 8px;
  padding-inline: 10px;
  background: var(--ds-c-white);
  ${textBreakLineWordMixin};
  ${displayFlexRowCenterStartMixin};
  user-select: none;
  cursor: not-allowed;

  &[readonly] {
    background: #ececf0;
    border: 1px solid var(--ds-c-blue-remox-light);
    color: var(--ds-c-grey-neutral);
    cursor: not-allowed;
  }
`;

const FormLabel = styled(Form.Label)`
  ${paragraph700Mixin};
  text-align: left;
  display: block;
  margin-bottom: 4px;

  span {
    color: var(--c-required);
  }
`;

export default FormInputDisplayOnly;
